enum FreeGiftTypeEnum {
    PRODUCT = "product",
    COUPON = "coupon",
}

export default FreeGiftTypeEnum;
